import React from 'react';
import reducer from './reducer/dish-menu/index.js';
import commonReducer from './reducer/common/index';
import GoodsDetailreducer from './reducer/goods-detail/index';
import ReducerContainer from './helper/reducer-helper';
import DishMenuApplication from './container/dish-menu/application.jsx';
import createRootApplication from './root-application';

createRootApplication(<DishMenuApplication />, ReducerContainer.appendReducer(reducer, commonReducer, GoodsDetailreducer));



// WEBPACK FOOTER //
// ./src/dish-menu.jsx